import React from 'react';
import { TIMEFRAMES, Timeframe } from '@/hooks';

interface TimeframeSwitcherProps {
  selected: Timeframe;
  onSelect: (timeframe: Timeframe) => void;
}

export const TimeframeSwitcher: React.FC<TimeframeSwitcherProps> = ({ selected, onSelect }) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '8px',
        justifyContent: 'center',
        padding: '12px 0',
      }}
    >
      {TIMEFRAMES.map((timeframe) => (
        <button
          key={timeframe}
          onClick={() => onSelect(timeframe)}
          style={{
            padding: '8px 16px',
            borderRadius: '20px',
            border: 'none',
            fontSize: '13px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            backgroundColor:
              selected === timeframe
                ? 'var(--tg-theme-button-color, #007AFF)'
                : 'var(--tg-theme-secondary-bg-color, #2C2C2E)',
            color:
              selected === timeframe
                ? 'var(--tg-theme-button-text-color, #FFFFFF)'
                : 'var(--tg-theme-hint-color, #8E8E93)',
          }}
        >
          {timeframe}
        </button>
      ))}
    </div>
  );
};
